import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const SingleColumnLayout = ({rendering}) => (
  <section className='single-col'>
    <Placeholder name="jss-single-col" rendering={ rendering }/>
  </section>
);

export default SingleColumnLayout;